/**
 * Non-operation function
 */
export function noop() {
  // Intentionally left blank
}

export default noop;
